import { render, staticRenderFns } from "./tgspecialarea.vue?vue&type=template&id=102c375e&"
import script from "./tgspecialarea.vue?vue&type=script&lang=js&"
export * from "./tgspecialarea.vue?vue&type=script&lang=js&"
import style0 from "./tgspecialarea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports